module.exports = __webpack_public_path__ + "img/barrackech.9dd91791.jpg";